// extracted by mini-css-extract-plugin
module.exports = {"link":"navlink-module--link--1qP2D","active":"navlink-module--active--2Q-NM"};